const aBankAdditionalRate = 0.06
const aBankAdditionalSecondRate = 0.055

export default {
  data() {
    return {
      pbRates: [
        {
          parts: 3,
          value: 0.09,
        },
        {
          parts: 4,
          value: 0.11,
        },
        {
          parts: 5,
          value: 0.12,
        },
        {
          parts: 6,
          value: 0.15,
        },
        {
          parts: 7,
          value: 0.16,
        },
        {
          parts: 8,
          value: 0.18,
        },
        {
          parts: 9,
          value: 0.19,
        },
        {
          parts: 10,
          value: 0.2,
        },
        {
          parts: 11,
          value: 0.19,
        },
        {
          parts: 12,
          value: 0.2,
        },
        {
          parts: 13,
          value: 0.23,
        },
        {
          parts: 14,
          value: 0.24,
        },
        {
          parts: 15,
          value: 0.26,
        },
        {
          parts: 16,
          value: 0.27,
        },
        {
          parts: 17,
          value: 0.29,
        },
        {
          parts: 18,
          value: 0.3,
        },
        {
          parts: 19,
          value: 0.31,
        },
        {
          parts: 20,
          value: 0.32,
        },
        {
          parts: 21,
          value: 0.35,
        },
        {
          parts: 22,
          value: 0.35,
        },
        {
          parts: 23,
          value: 0.37,
        },
        {
          parts: 24,
          value: 0.4,
        },
      ],
      pbIIRates: [
        {
          parts: 3,
          value: 0.039,
        },
        {
          parts: 4,
          value: 0.039,
        },
        {
          parts: 5,
          value: 0.039,
        },
        {
          parts: 6,
          value: 0.039,
        },
        {
          parts: 7,
          value: 0.039,
        },
        {
          parts: 8,
          value: 0.039,
        },
        {
          parts: 9,
          value: 0.039,
        },
        {
          parts: 10,
          value: 0.039,
        },
        {
          parts: 11,
          value: 0.049,
        },
        {
          parts: 12,
          value: 0.049,
        },
        {
          parts: 13,
          value: 0.049,
        },
        {
          parts: 14,
          value: 0.049,
        },
        {
          parts: 15,
          value: 0.049,
        },
        {
          parts: 16,
          value: 0.049,
        },
        {
          parts: 17,
          value: 0.049,
        },
        {
          parts: 18,
          value: 0.049,
        },
        {
          parts: 19,
          value: 0.049,
        },
        {
          parts: 20,
          value: 0.049,
        },
        {
          parts: 21,
          value: 0.049,
        },
        {
          parts: 22,
          value: 0.049,
        },
        {
          parts: 23,
          value: 0.049,
        },
        {
          parts: 24,
          value: 0.049,
        },
      ],
      monoRates: [
        {
          parts: 3,
          value: 0,
        },
        {
          parts: 4,
          value: 0,
        },
        {
          parts: 5,
          value: 0,
        },
        {
          parts: 6,
          value: 0,
        },
        {
          parts: 7,
          value: 0,
        },
        {
          parts: 8,
          value: 0,
        },
        {
          parts: 9,
          value: 0,
        },
        {
          parts: 10,
          value: 0,
        },
        {
          parts: 11,
          value: 0,
        },
        {
          parts: 12,
          value: 0,
        },
        {
          parts: 13,
          value: 0,
        },
        {
          parts: 14,
          value: 0,
        },
        {
          parts: 15,
          value: 0,
        },
        {
          parts: 16,
          value: 0,
        },
        {
          parts: 17,
          value: 0,
        },
        {
          parts: 18,
          value: 0,
        },
        {
          parts: 19,
          value: 0,
        },
        {
          parts: 20,
          value: 0,
        },
        {
          parts: 21,
          value: 0,
        },
        {
          parts: 22,
          value: 0,
        },
        {
          parts: 23,
          value: 0,
        },
        {
          parts: 24,
          value: 0,
        },
      ],
      aBankRates: [
        {
          parts: 2,
          value: 0.035,
        },
        {
          parts: 3,
          value: 0.055,
        },
        {
          parts: 4,
          value: 0.075,
        },
        {
          parts: 5,
          value: 0.1,
        },
        {
          parts: 6,
          value: 0.125 + aBankAdditionalRate,
        },
        {
          parts: 7,
          value: 0.145 + aBankAdditionalRate,
        },
        {
          parts: 8,
          value: 0.165 + aBankAdditionalRate,
        },
        {
          parts: 9,
          value: 0.175 + aBankAdditionalRate,
        },
        {
          parts: 10,
          value: 0.18 + aBankAdditionalRate,
        },
        {
          parts: 11,
          value: 0.185 + aBankAdditionalRate,
        },
        {
          parts: 12,
          value: 0.2 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 13,
          value: 0.215 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 14,
          value: 0.23 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 15,
          value: 0.245 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 16,
          value: 0.255 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 17,
          value: 0.27 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 18,
          value: 0.28 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 19,
          value: 0.295 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 20,
          value: 0.305 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 21,
          value: 0.32 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 22,
          value: 0.33 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 23,
          value: 0.34 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
        {
          parts: 24,
          value: 0.355 + aBankAdditionalRate + aBankAdditionalSecondRate,
        },
      ],
      alfaRates: [{}],
    }
  },
  methods: {
    productPrice(product, paymentMethod, partsCount) {
      if (paymentMethod === 'Online') {
        return product.newPrice
          ? Math.round(product.newPrice + product.newPrice * 0.027)
          : Math.round(product.price + product.price * 0.027)
      } else if (paymentMethod === 'PB_PP') {
        const rate = this.pbRates.filter(r => r.parts === partsCount)[0].value
        return product.newPrice
          ? Math.round(product.newPrice + product.newPrice * rate)
          : Math.round(product.price + product.price * rate)
      } else if (paymentMethod === 'PB_II') {
        const rate = this.pbIIRates.filter(r => r.parts === partsCount)[0].value
        return product.newPrice
          ? Math.round(product.newPrice + product.newPrice * rate)
          : Math.round(product.price + product.price * rate)
      } else if (paymentMethod === 'Mono') {
        const rate = this.monoRates.filter(r => r.parts === partsCount)[0].value
        const warrantiesPrice = this.selectedWarranties.reduce((sum, item) => {
          const itemChain = item.split(';')
          const selectedWarrantyPriceElement = itemChain.pop()
          const selectedWarrantyPriceNumber = Number(
            selectedWarrantyPriceElement
          )
          const selectedWarrantyPrice = Number.isNaN(
            selectedWarrantyPriceNumber
          )
            ? 0
            : selectedWarrantyPriceNumber
          return sum + selectedWarrantyPrice
        }, 0)
        return product.newPrice
          ? Math.round(
              product.newPrice + product.newPrice * rate + warrantiesPrice
            )
          : Math.round(product.price + product.price * rate + warrantiesPrice)
      } else if (paymentMethod === 'ABank') {
        const rate = this.aBankRates.filter(r => r.parts === partsCount)[0]
          .value
        return product.newPrice
          ? Math.round(product.newPrice + product.newPrice * rate)
          : Math.round(product.price + product.price * rate)
      } else if (this.paymentMethod === 'ABank2') {
        // const rate = 0.03 + 0.019 * partsCount
        const rate = 0.03
        return product.newPrice
          ? Math.round(product.newPrice + product.newPrice * rate)
          : Math.round(product.price + product.price * rate)
      } else {
        return product.newPrice ? product.newPrice : product.price
      }
    },
  },
}
